import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'businessContactCompanies',
  urlRoot: '/business_contact_companies'
})
